module.exports = __webpack_public_path__ + "06837f29e8b0955c4516a19440143cc9.fbx";